export const environment = {
  envName: 'uat',
  production: false,
  enableVConsole: true,
  base_url: 'https://uat-smartloan-api.starmoney.co.th/api',
  api_key_camera_log: 'E1HIufNagkiVJUoqaQDobzuC9U9ejf73',
  version: '2.0.53',
  updated_at: '20261029'
};
